import { render, staticRenderFns } from "./ManageUsersModal.vue?vue&type=template&id=5879d05c"
import script from "./ManageUsersModal.vue?vue&type=script&lang=js"
export * from "./ManageUsersModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports